import { ApiHelper } from './apiHelper';

export class CountryApi {
    loadCountries(token, callback, failureCallback) {
        const dataUrl = '/api/country/countries';

        new ApiHelper().getDataSecure(
            dataUrl,
            token,
            callback,
            failureCallback
        );
    }
}
